import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ad8cdac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mhn" }
const _hoisted_2 = { class: "mhn__modal" }
const _hoisted_3 = { class: "mhn__modal-row" }
const _hoisted_4 = { class: "mhn__modal-row-icon" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-message" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-message_text" }, " Покупка каналов "),
  /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-message_date" }, " 20 февраля в 09:17 ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-price_minus" }, "-500 руб.", -1))
const _hoisted_7 = { class: "mhn__modal-row" }
const _hoisted_8 = { class: "mhn__modal-row-icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-message" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-message_text" }, " Пополнение баланса "),
  /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-message_date" }, " 20 февраля в 09:17 ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mhn__modal-row-price_plus" }, "+1500 руб.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeftDown = _resolveComponent("IconArrowLeftDown")!
  const _component_IconPlus = _resolveComponent("IconPlus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mhn__overlay",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hiddenModal && _ctx.hiddenModal(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_IconArrowLeftDown)
        ]),
        _hoisted_5,
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_IconPlus)
        ]),
        _hoisted_9,
        _hoisted_10
      ])
    ])
  ]))
}